const { STATUS, CHECK_ID } = require('../constants');

const CALLBACK_ATTRS = [
  'data-success',
  'data-error',
  'data-cancel',
  'data-beforepayment',
  'data-validatepayment',
];

function checkCallbacks(scriptElement) {
  return CALLBACK_ATTRS.map((attr) => {
    const name = scriptElement && scriptElement.getAttribute ? scriptElement.getAttribute(attr) : null;
    if (!name) {
      return { attr, name: null, status: 'not_configured' };
    }
    const exists = typeof window !== 'undefined' && typeof window[name] === 'function';
    return { attr, name, status: exists ? 'configured' : 'broken_reference' };
  });
}

function runImplementationCheck(ctx) {
  const evidence = {};
  const problems = [];

  const merchantOk = !!ctx.merchant_id && !/^https?:\/\//i.test(ctx.merchant_id);
  evidence.merchantId = ctx.merchant_id;
  if (!merchantOk) {
    problems.push('merchant_id is missing or malformed');
  }

  const selectorFound = !!ctx.selector
    && typeof document !== 'undefined'
    && !!document.getElementById(ctx.selector);
  evidence.selectorFound = selectorFound;
  if (!selectorFound) {
    problems.push(`selector element "${ctx.selector}" not found in DOM`);
  }

  const https = typeof window !== 'undefined' && !!window.location && window.location.protocol === 'https:';
  evidence.https = https;
  if (!https) {
    problems.push('page is not served over HTTPS');
  }

  const callbacks = checkCallbacks(ctx.scriptElement);
  evidence.callbacks = callbacks;
  const broken = callbacks.filter((c) => c.status === 'broken_reference');
  if (broken.length) {
    problems.push(`callback(s) reference an undefined function: ${broken.map((c) => c.name).join(', ')}`);
  }

  let status = STATUS.PASS;
  if (!merchantOk || !selectorFound || broken.length) {
    status = STATUS.FAIL;
  } else if (!https) {
    status = STATUS.WARN;
  }

  return {
    id: CHECK_ID.IMPLEMENTATION,
    status,
    detail: problems.length ? problems.join('; ') : 'implementation config looks valid',
    evidence,
  };
}

module.exports = { runImplementationCheck, checkCallbacks, CALLBACK_ATTRS };
